import axios from 'axios';
import { AppData } from '@lightningjs/sdk';
import {
  ErrorCode,
  reportError,
} from 'services/analytics/reportingServicePage';
import { getAdTagParams } from 'support/playerUtils';

export type AdTagParams = {
  csid: string;
  guid: string;
  playerWidth: number;
  playerHeight: number;
};

export const getPauseAdImageUrls = async (params: AdTagParams) => {
  const { csid, guid, playerWidth, playerHeight } = params;
  let adImageUrl = '',
    adStart = '',
    adEnd = '';
  const impressionUrls = [];

  adImageUrl = AppData?.adParams?.platform.pauseads_url ?? '';

  if (AppData) {
    const adTagParams = await getAdTagParams({ url: adImageUrl }, guid, {
      w: playerWidth,
      h: playerHeight,
      csid,
    });
    adImageUrl = adTagParams?.url ?? adImageUrl;
  }

  const pauseAdUrl = adImageUrl;

  try {
    const response = await axios.request({
      url: pauseAdUrl,
      method: 'GET',
    });
    const xml = response.data;

    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(xml, 'text/xml');

    const staticResources = parsedDoc.getElementsByTagName('StaticResource');
    for (const staticResource of staticResources) {
      if (
        staticResource.getAttribute('creativeType') === 'image/png' &&
        staticResource.textContent
      ) {
        adImageUrl = staticResource.textContent;
        break;
      }
    }
    const impressions = parsedDoc.getElementsByTagName('Impression');
    for (const impression of impressions) {
      if (impression.textContent) impressionUrls.push(impression.textContent);
    }

    const trackingEvents = parsedDoc.getElementsByTagName('vmap:Tracking');
    for (const trackingEvent of trackingEvents) {
      if (trackingEvent.textContent) {
        if (trackingEvent.getAttribute('event') === 'breakStart') {
          adStart = trackingEvent.textContent;
        }
        if (trackingEvent.getAttribute('event') === 'breakEnd') {
          adEnd = trackingEvent.textContent;
        }
      }
    }
  } catch (e) {
    // Ignore
    reportError({ error: e, userFacing: false, code: ErrorCode.c15 });
  }

  return { adImageUrl, impressionUrls, adStart, adEnd };
};

export const sendPauseAdImpressions = (urls: string[]) => {
  urls.forEach(url => {
    axios.request({
      url,
      method: 'GET',
    });
  });
};
